import { INSTANCE_URL } from "Constants";
import { getRequest, postRequest } from "NetworkCall";

import { EXHIBITORSINSIGHT_TOTAL_NOOFEXHI } from "ExhibitorinsightNoofexhiAction";
import { EXHIBITORSINSIGHT_TOTAL_EXHILISTVIEW } from "ExhibitorinsightExhilistviewAction";
import { EXHIBITORSINSIGHT_TOTAL_EXHIPROFVIEW } from "ExhibitorinsightExhiprofviewAction";
import { EXHIBITORSINSIGHT_TOTAL_EXHISEARCH } from "ExhibitorinsightExhisearchAction";
import { EXHIBITORSINSIGHT_TOTAL_EXHIFAVO } from "ExhibitorinsightExhifavoAction";

export var EXHIBITORSINSIGHT_NOOFEXHI = "EXHIBITORSINSIGHT_NOOFEXHI";
export var EXHIBITORSINSIGHT_EXHILISTVIEW = "EXHIBITORSINSIGHT_EXHILISTVIEW";
export var EXHIBITORSINSIGHT_EXHIPROFVIEW = "EXHIBITORSINSIGHT_EXHIPROFVIEW";
export var EXHIBITORSINSIGHT_EXHISEARCH = "EXHIBITORSINSIGHT_EXHISEARCH";
export var EXHIBITORSINSIGHT_EXHIFAVO = "EXHIBITORSINSIGHT_EXHIFAVO";
export var EXHIBITORSINSIGHT_TOPEXHI_TABLELIST =
  "EXHIBITORSINSIGHT_TOPEXHI_TABLELIST";
export var EXHIBITORSINSIGHT_TOPEXHICOUN_TABLELIST =
  "EXHIBITORSINSIGHT_TOPEXHICOUN_TABLELIST";
export var EXHIBITORSINSIGHT_MOSTSEARKEYS_TABLELIST =
  "EXHIBITORSINSIGHT_MOSTSEARKEYS_TABLELIST";
export var EXHIBITORSINSIGHT_TOPTAGS_TABLELIST =
  "EXHIBITORSINSIGHT_TOPTAGS_TABLELIST";

// Charts
export const EXHIBITORSINSIGHT_ENGAGEMENT_BARCHART =
  "EXHIBITORSINSIGHT_ENGAGEMENT_BARCHART";

export var EXHIBITORSINSIGHT_SELECTED_ITEM = "EXHIBITORSINSIGHT_SELECTED_ITEM";
export var EXHIBITORSINSIGHT_ITEM_SELECTED = "EXHIBITORSINSIGHT_ITEM_SELECTED"; // main

export function onExhibitorsinsightMenuSelected(selectedMenu) {
  return (dispatch) => {
    dispatch({ type: EXHIBITORSINSIGHT_ITEM_SELECTED, payload: selectedMenu });
  };
}

export function dispatchAnalyticsData(data) {
  return (dispatch) => {
    //dispatch({type: EXHIBITORSINSIGHT_TOTAL_POST, payload: {count:data}}); count:data.devices.count
    dispatch({
      type: EXHIBITORSINSIGHT_TOTAL_NOOFEXHI,
      payload: { count: data },
    });
    dispatch({
      type: EXHIBITORSINSIGHT_TOTAL_EXHILISTVIEW,
      payload: { count: data },
    });
    dispatch({
      type: EXHIBITORSINSIGHT_TOTAL_EXHIPROFVIEW,
      payload: { count: data },
    });
    dispatch({
      type: EXHIBITORSINSIGHT_TOTAL_EXHISEARCH,
      payload: { count: data },
    });
    dispatch({
      type: EXHIBITORSINSIGHT_TOTAL_EXHIFAVO,
      payload: { count: data },
    });
  };
}

/******  Most search keywords (most search keywords related to Exhibitor) ******/

const fetchExhibitorsinsightMostsearkeysTableData = (session, callback) => {
  var url = `${INSTANCE_URL}/api/v2/analytics?type=mostsearkeyslist`;
  return (dispatch) => {
    postRequest(
      url,
      {
        type: "mostsearkeyslist",
        types: "search",
        screen: "exhibitors",
        eventid: session.eventid,
      },
      session,
      dispatch,
      (response) => {
        var data = response;

        //Prepare data for most search keywords related to exhibitors Table data (List) ..
        dispatch({
          type: EXHIBITORSINSIGHT_MOSTSEARKEYS_TABLELIST,
          data: data.resource,
        });
        callback({
          error: 0,
          data: "Analytics most search keywords related to exhibitors Table data Fetched !",
        });
      },
      (error) => {
        callback({ error: 1, data: null });
      }
    );
  };
};

// Top Exhibitor (Exhibitor profiles with most user engagement)
const fetchTopExhibitorTableData = (session, callback) => {
  // &types=entry&bkmrktypes=exhibitor&screen=exhibitors&eventid=${session.eventid}
  var url = `${INSTANCE_URL}/api/v2/analytics?type=topScreensTable`;
  return (dispatch) => {
    postRequest(
      url,
      {
        type: "topScreensTable",
        types: "entry",
        bkmrktypes: "exhibitor",
        screen: "exhibitors",
        tablename: "exhibitors",
        eventid: session.eventid,
      },
      session,
      dispatch,
      (response) => {
        var data = response;
        //Prepare data for Top exhibitors Table data (List) Installs..
        dispatch({
          type: EXHIBITORSINSIGHT_TOPEXHI_TABLELIST,
          data: data.resource,
        });
        callback({
          error: 0,
          data: "Analytics, Exhibitor profiles with most user engagement !",
        });
      },
      (error) => {
        callback({ error: 1, data: null });
      }
    );
  };
};

// Top Tags (most used tags related to exhibitors)
const fetchExhiToptagsTableData = (session, callback) => {
  var url = `${INSTANCE_URL}/api/v2/analytics?type=toptagsexhilist&eventid=${session.eventid}`;
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        var data = response;

        //Prepare data for most used tags related to exhibitors (List) Installs..
        dispatch({
          type: EXHIBITORSINSIGHT_TOPTAGS_TABLELIST,
          data: data.resource,
        });
        callback({
          error: 0,
          data: "Analytics Top exhibitors Table data Fetched !",
        });
      },
      (error) => {
        callback({ error: 1, data: null });
      }
    );
  };
};

// Top Countries (Countries from which top exhibitors belongs)
const fetchExhiTopCountriesTableData = (session, callback) => {
  var url = `${INSTANCE_URL}/api/v2/analytics?type=topexhicountrylist&types=exhibitor&eventid=${session.eventid}`;
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        var data = response;

        //Prepare data for Countries from which top exhibitors belongs (List) ..
        dispatch({
          type: EXHIBITORSINSIGHT_TOPEXHICOUN_TABLELIST,
          data: data.resource,
        });
        callback({
          error: 0,
          data: "Analytics Top exhibitors countries Table data Fetched !",
        });
      },
      (error) => {
        callback({ error: 1, data: null });
      }
    );
  };
};

// Exhibitors Engagement (CHART VIEW of how actively the exhibitor feature has been use over the selected date range)
const fetchexhiengagementbBarChart = (session, daterange, callback) => {
  var url = `${INSTANCE_URL}/api/v2/analytics?type=typesFeatureEngmntData`;

  return (dispatch) => {
    postRequest(
      url,
      {
        type: "typesFeatureEngmntData",
        screen: "exhibitors",
        bkmrktype: "exhibitor",
        eventid: session.eventid,
        fromDate: daterange.from,
        toDate: daterange.to,
      },
      session,
      dispatch,
      (response) => {
        var data = response;

        dispatch({
          type: EXHIBITORSINSIGHT_ENGAGEMENT_BARCHART,
          payload: { response: data.resource },
        });
        callback({
          error: 0,
          data: "Analytics, Chart view of how actively the exhibitor feature has been use over the selected date range !",
        });
      },
      (error) => {
        callback({ error: 1, data: null });
      }
    );
  };
};

export {
  fetchExhibitorsinsightMostsearkeysTableData,
  fetchTopExhibitorTableData,
  fetchExhiToptagsTableData,
  fetchExhiTopCountriesTableData,
  fetchexhiengagementbBarChart,
};
